import { FC, Fragment, useEffect, useState } from 'react';

import MenuItem from '../../dtos/MenuItem.dto';
import Spacer from '../../styled/Spacer';
import Text from '../../styled/Text';
import ActiveLink from '../ActiveLink';

interface DropDownContainerProps {
  menu: MenuItem;
  handleClose: Function;
  showDropdown : Boolean;
}

const DropdownItem: FC<DropDownContainerProps> = ({ menu, handleClose, showDropdown }) => {
  const [showMore, setShowMore] = useState(false);
  const [menuItems, setMenuItems] = useState<Array<MenuItem>>([]);

  useEffect(
    function () {
      if (!showMore) {
        setMenuItems(menu.children.filter((_, index) => index < 4));
      } else {
        setMenuItems(menu.children);
      }
    },
    [showMore],
  );

  return (
    <ul className="list-unstyled">
      {menuItems.map((menu: MenuItem) => (
        <li className="mb-2" key={menu.label} onClick={() => handleClose()}>
          <ActiveLink key={menu.label} href={menu.url}>
            <a style={{ color: '#000' }}>
              <Text fontSize="base" weight="normal">
                {menu.label}
              </Text>
            </a>
          </ActiveLink>
        </li>
      ))}
      {menu.children.length > 4 ? (
        <li className="mb-2" key="show">
          {showMore ? (
            <a onClick={() => setShowMore(false)}>
              {' '}
              <Text fontSize="md" color="primary">
                {' '}
                Show Less{' '}
              </Text>{' '}
            </a>
          ) : (
            <a onClick={() => setShowMore(true)}>
              {' '}
              <Text fontSize="md" color="primary">
                {' '}
                Show More
              </Text>{' '}
            </a>
          )}
        </li>
      ) : null}
    </ul>
  );
};

const DropDownContainer: FC<DropDownContainerProps> = ({
  menu,
  handleClose,
  showDropdown
}) => {
  return (
    <div className="container  py-4" style={{display : showDropdown ? 'block' : 'none'}}>
      <div className="row">
        {menu.children.map((menuItem: MenuItem) => {
          if (menuItem.label === 'Legal Consultation') {
            return (
              <div className="col-12 col-md-3">                
                <DropdownItem menu={menu} handleClose={handleClose} showDropdown/>
              </div>
            )
          } else {
            return (
              <Fragment key={menuItem.id}>
                {menuItem.children.length ? (
                  <div className="col-12 col-md-3">
                    <Text fontSize="base" fontFamily="manrope" weight="bold">
                      {menuItem.label}
                    </Text>
                    <Spacer direction="vertical" size={10} />
                    <DropdownItem menu={menuItem} handleClose={handleClose} showDropdown/>
                  </div>
                ) : null}
              </Fragment>
            )
          }
        })}
      </div>
    </div>
  );
};

export default DropDownContainer;